import React from 'react';

import ContentCard from '@JohnLewisPartnership/jlfs-ui-library/dist/components/contentCardSection/contentCard/contentCard';
import Link from '@JohnLewisPartnership/jlfs-ui-library/dist/components/link/link';

import {
  formatToTwoDecimals,
  getStoreStatus,
} from '../storeFinderUtils/storeFinderUtils';
import { TFormatStore } from '../../wrappers/StoreLocatorWrapper/StoreLocatorUtils/StoreLocatorUtils';
import styles from './StoreCards.module.scss';

export type TStoreCards = TFormatStore & {
  distance: number;
};

type TStoreCardsProps = {
  storeCards: TStoreCards[];
  visibleStores: number;
  updateVisibleStores: () => void;
  message: React.ReactNode;
  osakaChangesEnabled?: boolean;
};

export default function StoreCards({
  storeCards,
  visibleStores,
  updateVisibleStores,
  message,
  osakaChangesEnabled = false,
}: TStoreCardsProps) {
  const cards = storeCards.slice(0, visibleStores).map((store: TStoreCards) => {
    const storeStatus = getStoreStatus(store);
    const storeTitle = `${store?.division} ${store?.branchName}`;
    const storeLink = store.internalUrl ? (
      <Link href={store.internalUrl} title="View store details" />
    ) : store.externalUrl ? (
      <Link
        href={store.externalUrl.url}
        title="View store details"
        newTab={store.externalUrl.openInNewTab}
      />
    ) : null;

    return (
      <ContentCard
        key={storeTitle}
        icon={<img src="/icons/location-icon-small.svg" alt="Store location" />}
        iconAlignment="Left"
        image={null}
        title={storeTitle}
        backgroundColour="Dark Taupe"
        aria-label={`Store information for ${store.branchName}`}
        content={
          <div>
            <div className={styles.storeInfo}>
              <p className={styles.distance}>
                {formatToTwoDecimals(store.distance)} miles
              </p>
              <p>{storeStatus}</p>
            </div>
            <address className={styles.address}>
              <p>
                {store.division}
                {!osakaChangesEnabled && store.floor}
              </p>
              <p>{store.branchName}</p>
              <p>
                {store.fullAddress}, {store.postcode}
              </p>
            </address>
            {storeLink && (
              <div className={styles.storeDetailsBtn}>
                {storeLink}
              </div>
            )}
          </div>
        }
      />
    );
  });

  return storeCards.length > 0 ? (
    <section className={styles.cardContainer}>
      {message}
      {cards}
      {storeCards.length > 3 && visibleStores === 3 && (
        <button
          className={styles.expandButton}
          onClick={updateVisibleStores}
          aria-label="Show more stores"
        >
          <img src="/icons/plus.svg" alt="" />
          Show more stores
        </button>
      )}
    </section>
  ) : null;
}
